import { createSlice } from '@reduxjs/toolkit';
import { fetchGetRecordsTireFitting } from '../services/fetchGetRecordsTireFitting';
import { ServicesSchema } from '../types/TypeRecord';

const initialState: ServicesSchema = {
  userRecords: [],
  isLoadedUserRecords: false,
  isErrorUserRecords: null,
};

export const serviceSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(fetchGetRecordsTireFitting.pending, state => {
      state.isLoadedUserRecords = false;
    });
    builder.addCase(fetchGetRecordsTireFitting.fulfilled, (state, action) => {
      if (action.payload) {
        state.userRecords = action.payload.filter(x => !x.forNote);
      }
      state.isLoadedUserRecords = true;
    });
    builder.addCase(fetchGetRecordsTireFitting.rejected, (state, action) => {
      state.isLoadedUserRecords = true;
      state.isErrorUserRecords = { code: action.payload.code };
    });
  },
});

export const { actions: recordServiceActions } = serviceSlice;
